<template>
	<vs-row>
		<vs-col class="mb-6 md:mb-0" vs-justify="center" vs-align="center" vs-w="6" vs-sm="12" vs-lg="6">
		   <Number v-model="questionsByPage[index].properties.min" :label="$t(`MODULE.${labelMin}`)" :min="0" :max="maxi" :disabled="disabledMin"  @blur="validateMin"/>
		</vs-col>
		<vs-col vs-justify="center" vs-align="center" vs-w="6" vs-sm="12" vs-lg="6">
		   <Number v-model="questionsByPage[index].properties.max" :label="$t(`MODULE.${labelMax}`)" :min="mini" :disabled="disabledMax" @blur="validateMax"/>
		</vs-col>
	</vs-row>
</template>

<script type="text/javascript">
	import  Number  from '../components/Number.vue';
	import { mapState } from 'vuex';
		
	export default {		
		components: { Number },
		props: { 
			index: Number, 
			labelMin: {
				type: String,
		        required: false,
		        default: 'minValue'
			},
			labelMax: {
				type: String,
		        required: false,
		        default: 'maxValue'
			},
			disabledMin: {
				type: Boolean,
		        required: false,
		        default: false
			},
			disabledMax: {
				type: Boolean,
		        required: false,
		        default: false
			}

		},
		data() {
			return {
				propertyMin: 'min',
				propertyMax: 'max'
			}
		},
		methods: {
			validateMax() {
				if(this.maxi < this.mini) {
					this.questionsByPage[this.index].properties[this.propertyMax] = this.mini;
				}
			},
			validateMin() {
				if(this.mini > this.maxi) {
					this.questionsByPage[this.index].properties[this.propertyMin] = this.maxi;
				}
			}
		},		
		computed: {
			...mapState('resource',['questionsByPage']),
			maxi() {
				return this.questionsByPage[this.index].properties[this.propertyMax];
			},
			mini() {
				return this.questionsByPage[this.index].properties[this.propertyMin];
			}
		}
	}
</script>